import Vue from 'vue'
import Router from 'vue-router'
import ChatBox from '@/components/ChatBox'
import MinChat from '@/components/MinChat'
import Register from '@/components/Register'
import Rating from '@/components/Rating'
import Continue from '@/components/Continuechat'
import Endchatpage from '@/components/Endchatpage'
import showtest from '@/components/showtest'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/register/:servicename', component: Register, meta: {requiresLogin: false} },
    { path: '/chat/:servicename/:concode/:tokenroom', component: ChatBox },
    { path: '/minchat/:servicename', component: MinChat },
    { path: '/rating/:servicename/:caseid/:tokenuser', component: Rating },
    { path: '/continue/:servicename/:key', component: Continue },
    { path: '/score/:servicename/:caseid', component: Endchatpage },
    { path: '/showtest', component: showtest },
    { path: '*', redirect: '/register' }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresAuth)) {
    if (localStorage.getItem('status_login') !== 'T' || localStorage.getItem('status_login') === null) {
      next({ path: '/register' })
    } else {
      next()
    }
    return
  }
  next()
})
router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresLogin)) {
    if (localStorage.getItem('status_login') === 'T') {
      next({ path: '/register' })
    } else {
      next({ path: '/register' })
    }
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js